import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
//import { convertToLocalCurrency } from "../../../utils/currency";
import checkIcon from "../../../assets/icons/check.svg"
import { getPublisherById } from "../../../redux/slices/publisherSlice";

import BackButton from "../../../components/common/BackButton";
import { Container, Details } from "./ViewPublishersStyles";

const ViewPublishers = () => {
  const dispatch = useDispatch();
  const { publisherId } = useParams();

  const { publisher } = useSelector((state) => state.publisher);
  //console.log(publisher)

  useEffect(() => {
    dispatch(getPublisherById(publisherId));
  }, [dispatch, publisherId]);
  if (!publisher) {
    return <div> </div>;
  }

  return (
    <Container>
      <div className="heading">
        <div className="texts">
          <h1>{publisher.publisher?.name || "N/A"}</h1>
          <p>View your team’s trades and transactions.</p>
        </div>

        <div className="link-buttons">
        <BackButton></BackButton>
          <Link className="add-campaign" to="/create-publisher">
            + Add publisher
          </Link>
        </div>
      </div>
    
      <h4>Basic details</h4>
      <Details>
        <div className="wrapper">
            <label>Publisher name</label>
            <p>{publisher.publisher?.name || "N/A"}</p>
        </div>
        <hr />

        <div className="wrapper">
            <label>Url</label>
            <a className="url" href={publisher.publisher?.publisherUrl || "N/A"} rel="noreferrer" target="_blank">{publisher.publisher?.publisherUrl || "N/A"}</a>
        </div>
        <hr />

        <div className="wrapper">
            <label>Reference</label>
            <p>{publisher.publisher?.publisherReference || "N/A"}</p>
        </div>
        <hr />

        <div className="wrapper">
            <label>Identifier</label>
            <p>{publisher.publisher?.identifier || "N/A"}</p>
        </div>
        <hr />

        <div className="wrapper">
            <label>Click Id</label>
            <p>{publisher.publisher?.clickIdParameter || "N/A"}</p>
        </div>
        <hr />

        <div className="wrapper">
            <label>Source Id</label>
            <p>{publisher.publisher?.sourceIdParameter || "N/A"}</p>
        </div>
        <hr />

        <div className="wrapper">
            <label>Postback method</label>
            <p>{publisher.publisher?.postbackMethod || "GET"}</p>
        </div>
        {publisher.publisher?.postbackMethod === "POST" && (
          <>
            <hr />
            <div className="wrapper">
                <label>Postback body</label>
                <pre style={{ margin: 0, whiteSpace: "pre-wrap", wordBreak: "break-all" }}>
                  {JSON.stringify(publisher.publisher?.postbackBody, null, 2)}
                </pre>
            </div>
          </>
        )}
      </Details>
      <hr className="outside"/>

      <h4>Figures</h4>
      <Details>
        <div className="wrapper">
            <label>Total campaigns</label>
            <p>{publisher.totalCampaigns || "0"}</p>
        </div>
        <hr />
        <div className="wrapper">
            <label>Total Clicks</label>
            <p>{publisher.totalClicks || "0"}</p>
        </div>
        <hr />
        <div className="wrapper">
            <label>Total Conversion</label>
            <p>{publisher.totalConversion || "0"}</p>
        </div>
        <hr />
        <div className="wrapper">
            <label>Total Conversion rate</label>
            <p>{`${publisher.totalConversionRate}%` || "0"}</p>
        </div>
      </Details>
      <hr className="outside"/>

      <h4>Status</h4>
      <Details>
        <div className="wrapper">
            <label>Activated</label>
            {publisher.publisher?.isActive ? <img src={checkIcon} alt="check" /> : null}
        </div>
        <hr />
        <div className="wrapper">
            <label>Deactivated</label>
            {publisher.publisher?.isActive === false ? <img src={checkIcon} alt="check" /> : null}
        </div>
      </Details>
      <hr className="outside"/>

        
    </Container>
  );
};

export default ViewPublishers;
